import * as firebase from 'firebase/app'
import 'firebase/functions'
import 'firebase/auth'
import { get, post } from 'scripts/helpers/Utils'
import locale from 'shared/i18n/react'
import Constants from 'scripts/base/Constants'

if (typeof global.app !== 'undefined') {
  const config = {
    apiKey: global.app.FIREBASE_API_KEY,
    authDomain: global.app.FIREBASE_AUTH_DOMAIN,
    databaseURL: global.app.FIREBASE_DATABASE_URL,
    projectId: global.app.FIREBASE_PROJECT_ID,
    storageBucket: global.app.FIREBASE_STORAGE_BUCKET,
    messagingSenderId: global.app.FIREBASE_SENDER_ID
  }

  firebase.initializeApp(config)
}
export const authRef = (typeof global.app !== 'undefined') && firebase.auth()
export const googleLogin = new firebase.auth.GoogleAuthProvider()
export const facebookLogin = new firebase.auth.FacebookAuthProvider()

export const session = {
  get: () => {
    const lang = locale.getLanguage()
    const urlPrefix = lang !== Constants.DefaultLang ? `${lang}/` : ''

    return new Promise(resolve => {
      get({
        url: `${urlPrefix}users/session`,
        domain: ''
      }).then(response => {
        const {data} = response
        if (data.auth === 'NO') {
          resolve({auth: 'NO', user: false})
        } else {
          resolve(data)
        }
      }).catch(e => {
        resolve({auth: 'NO', user: false})
      })
    })
  },
  set: (auth) => {
    const lang = locale.getLanguage()
    const urlPrefix = lang !== Constants.DefaultLang ? `${lang}/` : ''

    return new Promise(resolve => {
      if (auth === false) { return resolve({auth: 'NO'}) }
      authRef.currentUser.getIdToken(true).then((idToken) => {
        post({
          url: `${urlPrefix}users/login`,
          domain: '',
          headers: null,
          params: { token: idToken }
        }).then((res) => {
          resolve(res.data)
        }).catch(e => {
          resolve({auth: 'Error'})
        })
      })
    })
  },
  del: () => {
    const lang = locale.getLanguage()
    const urlPrefix = lang !== Constants.DefaultLang ? `${lang}/` : ''

    return new Promise(resolve => {
      authRef.signOut().then(() => {
        get({
          url: `${urlPrefix}users/logout`,
          domain: ''
        }).then(res => {
          resolve(res.data)
        })
      }).catch(e => {
        console.log(e)
        resolve(e)
      })
    })
  }
}

export const SendReaction = (id, type, prevType) => {
  const lang = locale.getLanguage()
  const urlPrefix = lang !== Constants.DefaultLang ? `${lang}/` : ''

  return new Promise(resolve => {
    post({
      url: `${urlPrefix}users/reactions/${id}/${type}/${prevType !== '' ? prevType : ''}`,
      domain: ''
    }).then(res => {
      resolve(res.data)
    }).catch(e => {
      resolve({errorMessage: 'Failed to send reaction, please try again later.'})
    })
  })
}

export const GetReactions = (id) => {
  const lang = locale.getLanguage()
  const urlPrefix = lang !== Constants.DefaultLang ? `${lang}/` : ''

  return new Promise(resolve => {
    get({
      url: `${urlPrefix}users/reactions/${id}`,
      domain: ''
    }).then(res => {
      resolve(res.data)
    }).catch(e => {
      resolve({errorMessage: 'Failed to send reaction, please try again later.'})
    })
  })
}



// WEBPACK FOOTER //
// ./assets/js/lib/firebase/index.js